import React from "react";
import { Helmet } from "react-helmet";
import {cartItem} from "../../models/cart.model";
import {getStructuredItem} from "../../helpers/scripts/seoScript";

interface IItemScript {
    item: cartItem,
    scriptType: string,
    location_id: number,
    userId: number
}

const SelectMenuItemScript: React.FunctionComponent<IItemScript> = ({item, scriptType, location_id, userId}) =>
{
    const itemDetails = getStructuredItem(item, location_id)

    return (
        <>
            <Helmet>
                <script>
                    {
                        `    
                      window.dataLayer.push({
                        'event': ${JSON.stringify(scriptType)},
                        'user_id': ${userId || null},
                        'ecommerce': {
                            item_list_id: "${item?.category_id}",
                            item_list_name: "${item?.category_name}",
                            'items': [
                                ${JSON.stringify(itemDetails)}
                            ]
                        }
                    });
                     `
                    }
                </script>
            </Helmet>
        </>
    );
};

export default SelectMenuItemScript;
